import { Field } from 'Util/Query';
import { isSignedIn } from 'Util/Auth';

/** @namespace TikTokFeed/TikTokLogin/Query */
export class TikTokLoginQuery {
    getTikTokLoginMutation(options) {
        const { code, scopes, state } = options;
        if (!isSignedIn()) {
        return new Field('TikTokAuth')
            .addArgument('code', 'String!', code)
            .addArgument('scopes', 'String!', scopes)
            .addArgument('state', 'String!', state)
            .addField('token');
        }

        return;
    }
}
export default new TikTokLoginQuery();
